export default __webpack_public_path__ + "static/media/1SocialMedia_W.82a1f9ce.png";